export const paginationFilter = (data, nowPage, rowsPage) => {
  if (!Array.isArray(data)) return [];
  const res = data.slice(nowPage * rowsPage, nowPage * rowsPage + rowsPage);
  return res;
};
